export default __webpack_public_path__ + "files/media/plane-mobile.4a2f358c.webp";